/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PackageMedicine from './package-medicine';
import PackageMedicineDetail from './package-medicine-detail';
import PackageMedicineUpdate from './package-medicine-update';
import PackageMedicineDeleteDialog from './package-medicine-delete-dialog';

const PackageMedicineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PackageMedicine />} />
    <Route path="new" element={<PackageMedicineUpdate />} />
    <Route path=":id">
      <Route index element={<PackageMedicineDetail />} />
      <Route path="edit" element={<PackageMedicineUpdate />} />
      <Route path="delete" element={<PackageMedicineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PackageMedicineRoutes;
